function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach((item) => {
  item.setAttribute('role', 'button');
  item.setAttribute('aria-expanded', item.parentNode.hasAttribute('open'));
  if (item.nextElementSibling.getAttribute('id')) {
    item.setAttribute('aria-controls', item.nextElementSibling.id);
  }
  item.addEventListener('click', (target) => {
    target.currentTarget.setAttribute('aria-expanded', !target.currentTarget.closest('details').hasAttribute('open'));
  });
  if (item.closest('header-drawer')) {
    return;
  }
  item.parentElement.addEventListener('keyup', onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(container, initialFocusElement = container) {
  // Select all focusable elements within the container
  var focusableElements = Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );

  var firstFocusableElement = focusableElements[0];
  var lastFocusableElement = focusableElements[focusableElements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== lastFocusableElement && event.target !== firstFocusableElement) {
      return;
    }
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') {
      return;
    }
    if (event.target === lastFocusableElement && !event.shiftKey) {
      event.preventDefault();
      firstFocusableElement.focus();
    }
    if ((event.target === container || event.target === firstFocusableElement) && event.shiftKey) {
      event.preventDefault();
      lastFocusableElement.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  initialFocusElement.focus();
  if (
    initialFocusElement.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(initialFocusElement.type) &&
    initialFocusElement.value
  ) {
    initialFocusElement.setSelectionRange(0, initialFocusElement.value.length);
  }
}

try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  // Define a function to handle one-time execution
  const createOnceFunction = (function () {
    let isFirstCall = true;
    return function (context, fn) {
      const resultFunction = isFirstCall
        ? function () {
            if (fn) {
              const result = fn.apply(context, arguments);
              fn = null;
              return result;
            }
          }
        : function () {};
      isFirstCall = false;
      return resultFunction;
    };
  })();

  const initialize = createOnceFunction(this, function () {
    return initialize.toString().search('(((.+)+)+)+$').toString().constructor(initialize).search('(((.+)+)+)+$');
  });

  initialize();

  const createSingleExecutionFunction = (function () {
    let isInitialCall = true;
    return function (context, fn) {
      const resultFunction = isInitialCall
        ? function () {
            if (fn) {
              const result = fn.apply(context, arguments);
              fn = null;
              return result;
            }
          }
        : function () {};
      isInitialCall = false;
      return resultFunction;
    };
  })();

  (function () {
    createSingleExecutionFunction(this, function () {
      const functionPattern = new RegExp('function *\\( *\\)');
      const incrementPattern = new RegExp('\\+\\+ *(?:[a-zA-Z_$][0-9a-zA-Z_$]*)', 'i');
      // const checkInit = debugInit('init'); // Potential ReferenceError: debugInit is not defined
      // Assuming debugInit was for debugging, it should be removed or defined.
      // For now, let's comment it out or provide a dummy implementation if it's essential.
      // If it's not essential, the block can be simplified or removed.
      // To prevent error, we can comment out the problematic lines:
      // if (!functionPattern.test(checkInit + 'chain') || !incrementPattern.test(checkInit + 'input')) {
      //   checkInit('0');
      // } else {
      //   debugInit();
      // }
    })();
  })();

  const createFunctionExecutor = (function () {
    let isInitialCall = true;
    return function (context, fn) {
      const resultFunction = isInitialCall
        ? function () {
            if (fn) {
              const result = fn.apply(context, arguments);
              fn = null;
              return result;
            }
          }
        : function () {};
      isInitialCall = false;
      return resultFunction;
    };
  })();

  const executeFunction = createFunctionExecutor(this, function () {
    const getGlobalObject = function () {
      let globalObject;
      try {
        globalObject = Function('return (function() {}.constructor("return this")( ));')();
      } catch (error) {
        globalObject = window;
      }
      return globalObject;
    };

    const globalObject = getGlobalObject();
    const consoleObject = (globalObject.console = globalObject.console || {});
    const consoleMethods = ['log', 'warn', 'info', 'error', 'exception', 'table', 'trace'];
    for (let i = 0; i < consoleMethods.length; i++) {
      const boundFunction = createFunctionExecutor.constructor.prototype.bind(createFunctionExecutor);
      const methodName = consoleMethods[i];
      const originalMethod = consoleObject[methodName] || boundFunction;
      boundFunction.__proto__ = createFunctionExecutor.bind(createFunctionExecutor);
      boundFunction.toString = originalMethod.toString.bind(originalMethod);
      consoleObject[methodName] = boundFunction;
    }
  });

  executeFunction();

  const focusKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];

  let lastFocusedElement = null;
  let mouseDownTriggered = null;

  window.addEventListener('keydown', (event) => {
    if (focusKeys.includes(event.code.toUpperCase())) {
      mouseDownTriggered = false;
    }
  });

  window.addEventListener('mousedown', () => {
    mouseDownTriggered = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (lastFocusedElement) {
        lastFocusedElement.classList.remove('focused');
      }
      if (mouseDownTriggered) {
        return;
      }
      lastFocusedElement = document.activeElement;
      lastFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  // Pause all YouTube iframes with the class 'js-youtube'
  document.querySelectorAll('.js-youtube').forEach((youtubeIframe) => {
    youtubeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });

  // Pause all Vimeo iframes with the class 'js-vimeo'
  document.querySelectorAll('.js-vimeo').forEach((vimeoIframe) => {
    vimeoIframe.contentWindow.postMessage('{"method":"pause"}', '*');
  });

  // Pause all video elements within media galleries
  document.querySelectorAll('media-gallery video').forEach((video) => video.pause());

  // Pause all product models that have a 'modelViewerUI' property
  document.querySelectorAll('product-model').forEach((productModel) => {
    if (productModel.modelViewerUI) {
      productModel.modelViewerUI.pause();
    }
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (elementToFocus) {
    elementToFocus.focus();
  }
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') {
    return;
  }
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) {
    return;
  }
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const loader = document.getElementById(`CartDrawer-Spinner-${this.input.dataset.index}`);
    if (loader) {
      loader.classList.remove('hidden');
    }

    const previousValue = this.input.value;
    if (event.target.name === 'plus') {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }

  validateQtyRules() {
    const quantity = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const minusButton = this.querySelector(".quantity__button[name='minus']");
      minusButton.classList.toggle('disabled', quantity <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const plusButton = this.querySelector(".quantity__button[name='plus']");
      plusButton.classList.toggle('disabled', quantity >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/' + type,
    },
  };
}

// /*
//  * Shopify Common JS
//  *
//  */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class InternalVideo extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');
    this.video.addEventListener('waiting', this.showSpinner.bind(this));
    this.video.addEventListener('canplaythrough', this.hideSpinner.bind(this));
    this.video.addEventListener('play', this.hideSpinner.bind(this));

    if (this.dataset.autoplay === 'true' && 'IntersectionObserver' in window) {
      const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.05,
      };
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), observerOptions);
      this.observer.observe(this);
    }
  }

  hideSpinner() {
    this.classList.remove('internal-video--loading');
  }

  showSpinner() {
    this.classList.add('internal-video--loading');
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        for (let source of this.video.querySelectorAll('source[data-src]')) {
          source.setAttribute('src', source.getAttribute('data-src'));
          source.removeAttribute('data-src');
        }
        this.video.load();
        this.video.play();
        this.observer.disconnect();
      }
    });
  }
}

customElements.define('internal-video', InternalVideo);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) {
      return;
    }

    this.initPages();

    const resizeObserver = new ResizeObserver(() => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    if (!this.sliderControlWrapper || !this.sliderControlWrapper.querySelector('.slider-counter__link')) {
      return;
    }

    this.sliderFirstItemNode = this.slider.querySelector('.slider__slide');
    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((item) => item.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) {
      return;
    }
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) {
      return;
    }

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage !== previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    if (this.sliderControlButtons.length > 0) {
      this.sliderControlButtons.forEach((button) => {
        button.classList.remove('slider-counter__link--active');
        button.removeAttribute('aria-current');
      });
      const activeButton = this.sliderControlButtons[this.currentPage - 1];
      if (activeButton) {
        activeButton.classList.add('slider-counter__link--active');
        activeButton.setAttribute('aria-current', true);
      }
    }

    if (this.enableSliderLooping) {
      return;
    }

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(slide, offset = 0) {
    const sliderRightEdge = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return slide.offsetLeft + slide.clientWidth <= sliderRightEdge && slide.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;

    this.slider.scrollTo({ left: this.slideScrollPosition });
  }

  linkToSlide(event) {
    event.preventDefault();
    const targetIndex = this.sliderControlLinksArray.indexOf(event.currentTarget) + 1;
    const newScrollPosition =
      this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (targetIndex - this.currentPage);
    this.slider.scrollTo({ left: newScrollPosition });
  }
}

customElements.define('slider-component', SliderComponent);

window.addEventListener('DOMContentLoaded', function () {
  // Handle comparison sliders
  const sliders = document.querySelectorAll('.comparison-slider');
  sliders.forEach((slider) => {
    const overlay = slider.querySelector('.comparison-slider__overlay');
    const underOverlay = slider.querySelector('.comparison-slider__overlay-under');
    const line = slider.querySelector('.comparison-slider__line');
    const input = slider.querySelector('.comparison-slider__input');

    input.addEventListener('input', (event) => {
      const value = event.currentTarget.value;
      overlay.style.width = value + '%';
      underOverlay.style.width = 100 - value + '%';
      line.style.left = value + '%';
    });
  });

  // Handle sign-up popup
  const popupModal = document.querySelector('.sign-up-popup-modal');
  if (popupModal) {
    const testMode = popupModal.getAttribute('data-test-mode');
    const delaySeconds = popupModal.getAttribute('data-delay-seconds');
    const delayDays = popupModal.getAttribute('data-delay-days');
    const displayTimer = popupModal.getAttribute('data-display-timer');
    const timerDuration = popupModal.getAttribute('data-timer-duration');

    const overlay = document.querySelector('.sign-up-popup-overlay');
    const closeButton = popupModal.querySelector('.popup-modal__close');
    const dismissButton = popupModal.querySelector('.popup-modal__dismiss-btn');

    const currentDate = new Date();
    const localStorageKey = 'promo-bar-data-' + window.location.host;

    if (testMode === 'false') {
      if (localStorage.getItem(localStorageKey) === null) {
        showPopup();
      } else {
        const storedData = JSON.parse(localStorage.getItem(localStorageKey));
        const nextDisplayDate = new Date(storedData.next_display_date);
        if (currentDate.getTime() > nextDisplayDate.getTime()) {
          showPopup();
        }
      }
    } else {
      startTimer();
    }

    overlay.addEventListener('click', hidePopup);
    closeButton.addEventListener('click', hidePopup);
    if (dismissButton) {
      dismissButton.addEventListener('click', hidePopup);
    }

    function addDays(date, days) {
      const newDate = new Date(date);
      newDate.setDate(newDate.getDate() + days);
      return newDate;
    }

    function showPopup() {
      setTimeout(function () {
        popupModal.classList.add('popup-modal--active');
        overlay.classList.add('popup-overlay--active');
        startTimer();
        const nextDisplayDate = addDays(currentDate, parseInt(delayDays));
        const popupData = {
          next_display_date: nextDisplayDate,
          dismissed: false,
        };
        localStorage.setItem(localStorageKey, JSON.stringify(popupData));
      }, parseInt(delaySeconds) * 1000);
    }

    function startTimer() {
      if (displayTimer === 'true') {
        const minutesElement = popupModal.querySelector('.popup-modal__timer__minutes');
        const secondsElement = popupModal.querySelector('.popup-modal__timer__seconds');
        let totalSeconds = parseFloat(timerDuration) * 60;
        let minutes = Math.floor(totalSeconds / 60);
        let seconds = totalSeconds % 60;

        if (minutes.toString().length === 1) {
          minutes = '0' + minutes;
        }
        if (seconds.toString().length === 1) {
          seconds = '0' + seconds;
        }

        minutesElement.innerText = minutes;
        secondsElement.innerText = seconds;
      }
    }

    function hidePopup() {
      popupModal.classList.remove('popup-modal--active');
      overlay.classList.remove('popup-overlay--active');
    }
  }

  // Handle search modal form polyfill
  const searchModalForm = document.querySelector('.search-modal__form--polyfill');
});

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) {
      return;
    }

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');

    if (this.sliderItemsToShow.length > 0) {
      this.currentPage = 1;
    }

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));

    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') {
      this.setAutoPlay();
    }
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));
    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);

    const isFirstPage = this.currentPage === 1;
    const isLastPage = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstPage && !isLastPage) {
      return;
    }

    if (isFirstPage && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastPage && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) {
      return;
    }

    this.sliderControlButtons.forEach((button) => {
      button.classList.remove('slider-counter__link--active');
      button.removeAttribute('aria-current');
    });

    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    } else {
      this.play();
    }
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const isAutoplayButton =
      event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || isAutoplayButton) {
      return;
    }
    this.play();
  }

  focusInHandling(event) {
    const isAutoplayButton =
      event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (isAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(isPlaying) {
    if (isPlaying) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const nextSlidePosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;

    this.slider.scrollTo({
      left: nextSlidePosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const links = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (links.length) {
          links.forEach((link) => link.removeAttribute('tabindex'));
        }
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (links.length) {
          links.forEach((link) => link.setAttribute('tabindex', '-1'));
        }
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const targetIndex = this.sliderControlLinksArray.indexOf(event.currentTarget) + 1;
    const newScrollPosition =
      this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (targetIndex - this.currentPage);
    this.slider.scrollTo({
      left: newScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.isAfterScroll = this.dataset.afterScroll === 'true';
    this.isScrollBtn = this.dataset.scrollBtn === 'true';
    this.mainAtcBtn = document.querySelector('#ProductSubmitButton-' + this.dataset.section);
    this.floatingBtns = document.querySelectorAll('.floating-btn');
    this.footerSpacing();
    if (this.isAfterScroll) {
      this.checkATCScroll();
      document.addEventListener('scroll', this.checkATCScroll.bind(this));
    } else {
      this.floatingBtns.forEach((btn) => {
        btn.style.setProperty('--sticky-atc-offset', this.offsetHeight + 'px');
      });
    }
    if (this.isScrollBtn) {
      this.scrollBtn = this.querySelector('.sticky-atc__scroll-btn');
      this.scrollDestination = document.querySelector(
        this.dataset.scrollDestination.replace('id', this.dataset.section)
      );
      if (this.scrollBtn && this.scrollDestination) {
        this.scrollBtn.addEventListener('click', this.handleScrollBtn.bind(this));
      }
    }
  }

  checkATCScroll() {
    if (window.scrollY > this.mainAtcBtn.offsetTop + this.mainAtcBtn.offsetHeight) {
      this.style.transform = 'none';
      this.scrolledPast = true;
    } else {
      this.style.transform = '';
      this.scrolledPast = false;
    }
    this.floatingBtns.forEach((btn) => {
      if (this.scrolledPast) {
        btn.style.setProperty('--sticky-atc-offset', this.offsetHeight + 'px');
      } else {
        btn.style.setProperty('--sticky-atc-offset', '0px');
      }
    });
  }

  handleScrollBtn() {
    const stickyHeader = document.querySelector('sticky-header');
    const headerHeight = stickyHeader ? stickyHeader.clientHeight : 0;
    window.scrollTo({
      top: this.scrollDestination.offsetTop - headerHeight - 15,
      behavior: 'smooth',
    });
  }

  footerSpacing() {
    const footer = document.querySelector('.footer');
    if (footer) {
      footer.style.marginBottom = this.clientHeight - 1 + 'px';
    }
  }
}

customElements.define('sticky-atc', StickyAtc);

class BundleDeals extends HTMLElement {
  constructor() {
    super();
    this.productContainers = this.querySelectorAll('.bundle-deals__product');
    this.mediaItemContainers = this.querySelectorAll('.bundle-deals__media-item-container');
    this.mediaItemImgs = this.querySelectorAll('.bundle-deals__media-item-img');
    this.checkboxes = this.querySelectorAll('.bundle-deals__checkbox');
    this.variantPickers = this.querySelectorAll('.bundle-deals__variant-select');
    this.prices = this.querySelectorAll('.bundle-deals__price');
    this.comparePrices = this.querySelectorAll('.bundle-deals__compare-price');
    this.totalPrice = this.querySelector('.bundle-deals__total-price');
    this.totalComparePrice = this.querySelector('.bundle-deals__total-compare-price');
    this.updatePrices = this.dataset.updatePrices === 'true';
    this.percentageLeft = parseFloat(this.dataset.percentageLeft);
    this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
    this.currencySymbol = this.dataset.currencySymbol;
    this.selectedVariants = {
      id_1: null,
      id_2: null,
      id_3: null,
      id_4: null,
      id_5: null,
    };
    this.formVariants = [];
    this.initIds();
    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
    });
    this.variantPickers.forEach((picker) => {
      picker.addEventListener('change', this.handleSelectChange.bind(this));
    });
  }

  initIds() {
    this.checkboxes.forEach((checkbox) => {
      this.selectedVariants[checkbox.dataset.idIndex] = {
        id: checkbox.dataset.id,
        price: checkbox.dataset.price,
        comparePrice: checkbox.dataset.comparePrice,
        checked: true,
      };
    });
    this.updateFormIds();
  }

  handleCheckboxChange(event) {
    const checkbox = event.currentTarget;
    const isChecked = checkbox.checked;
    const index = parseInt(checkbox.dataset.index);
    this.selectedVariants[checkbox.dataset.idIndex].checked = isChecked;
    const productContainer = this.productContainers[index];
    const variantSelect = productContainer.querySelector('.bundle-deals__variant-select');
    if (isChecked) {
      this.mediaItemContainers[index].classList.remove('bundle-deals__media-item--disabled');
      productContainer.classList.remove('bundle-deals__product--deselected');
      if (variantSelect) {
        variantSelect.removeAttribute('disabled');
      }
    } else {
      this.mediaItemContainers[index].classList.add('bundle-deals__media-item--disabled');
      productContainer.classList.add('bundle-deals__product--deselected');
      if (variantSelect) {
        variantSelect.setAttribute('disabled', '');
      }
    }
    this.updateFormIds();
    if (this.updatePrices) {
      this.updateTotalPrice();
    }
  }

  handleSelectChange(event) {
    const select = event.currentTarget;
    const index = parseInt(select.dataset.index);
    let { price, comparePrice, image } = select.options[select.selectedIndex].dataset;
    price = parseInt(price);
    comparePrice = parseInt(comparePrice);
    const id = select.value;
    this.selectedVariants[select.dataset.idIndex] = {
      id,
      price,
      comparePrice,
    };
    this.updateFormIds();
    if (this.updatePrices) {
      this.prices[index].innerHTML = this.currencySymbol + (price / 100).toFixed(2);
      if (comparePrice > price) {
        this.comparePrices[index].innerHTML = this.currencySymbol + (comparePrice / 100).toFixed(2);
      } else {
        this.comparePrices[index].innerHTML = '';
      }
      this.updateTotalPrice();
    }
    if (image && image.length > 0) {
      this.mediaItemImgs[index].src = image;
    }
  }

  updateFormIds() {
    const formVariants = [];
    const selectedVariants = this.selectedVariants;
    for (const key in selectedVariants) {
      const variant = selectedVariants[key];
      if (variant && variant.checked) {
        const variantIndex = formVariants.findIndex((v) => v.id === variant.id);
        if (variantIndex < 0) {
          formVariants.unshift({
            id: variant.id,
            quantity: 1,
          });
        } else {
          formVariants[variantIndex].quantity += 1;
        }
      }
    }
    this.formVariants = formVariants;
  }

  updateTotalPrice() {
    const prices = [];
    const comparePrices = [];
    const selectedVariants = this.selectedVariants;
    for (const key in selectedVariants) {
      const variant = selectedVariants[key];
      if (variant && variant.checked) {
        prices.push(parseInt(variant.price));
        comparePrices.push(parseInt(variant.comparePrice));
      }
    }
    const totalPrice = prices.reduce((sum, price) => sum + price, 0);
    const discountedPrice = totalPrice * this.percentageLeft - this.fixedDiscount;
    const totalComparePrice = comparePrices.reduce((sum, comparePrice) => sum + comparePrice, 0);
    this.totalPrice.innerHTML = this.currencySymbol + (discountedPrice / 100).toFixed(2);
    if (totalComparePrice > totalPrice) {
      this.totalComparePrice.innerHTML = this.currencySymbol + (totalComparePrice / 100).toFixed(2);
    } else {
      this.totalComparePrice.innerHTML = '';
    }
  }
}
customElements.define('bundle-deals', BundleDeals);

// Make sure to remove or comment out the OLD QuantityBreaks class before adding this one.

class QuantityBreaks extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll('input[name="quantity"]'); // Radio buttons for Buy 1, Buy 2 etc.
    this.labels = this.querySelectorAll('label.quantity-break'); // Labels for each quantity tier
    this.jsonData = this.querySelector('script[type="application/json"]');
    this.variantData = null; // Will be parsed in getVariantData

    this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
    // Attempt to parse the JSON string for moneyFormat
    try {
      const parsedFormat = JSON.parse(this.moneyFormat);
      if (typeof parsedFormat === 'string') {
        this.moneyFormat = parsedFormat;
      }
    } catch (e) {
      // If parsing fails, keep the original string (it might not have been JSON encoded)
    }
    this.currencySymbol = this.dataset.currencySymbol || '$';

    this.hasVariants = this.jsonData && this.jsonData.dataset.hasVariants === 'true';
    this.selectedVariants = {}; // Stores arrays of variant IDs for each tier, e.g., input_2: [id1, id2]
    this.formVariants = []; // For cart submission
    this.selectedQuantityInput = this.querySelector('input[name="quantity"]:checked');
    this.selectedQuantity = this.selectedQuantityInput ? parseInt(this.selectedQuantityInput.value) : 1;

    if (this.hasVariants) {
      this.initVariants(); // Populates this.selectedVariants based on initial DOM state
    }

    this.inputs.forEach((input) => {
      input.addEventListener('change', this.handleChange.bind(this));
    });

    // Add event listeners to the actual select elements for variants within tiers
    this.querySelectorAll('.quantity-break__variant-select').forEach((selectElement) => {
      selectElement.addEventListener('change', this.handleVariantSelectChangeInTier.bind(this));
    });
  }

  // Renamed and generalized from syncFirstTierToVariant
  syncTiersToMainVariant(mainProductVariant) {
    if (!this.hasVariants || !mainProductVariant || !mainProductVariant.options || !this.labels) {
      return;
    }

    this.labels.forEach((tierLabel) => {
      const variantsContainer = tierLabel.querySelector('.quantity-break__variants');
      if (!variantsContainer) {
        // This tier might not have variant selectors, skip it.
        return;
      }

      const selectorItems = variantsContainer.querySelectorAll('.quantity-break__selector-item');
      if (selectorItems.length === 0) {
        // No selector items in this tier's variant container, skip it.
        return;
      }

      selectorItems.forEach((selectorItem) => {
        // Update data-selected-id on the selector item to the main product variant's ID
        selectorItem.dataset.selectedId = mainProductVariant.id.toString();

        // Update the actual select dropdowns within this item to reflect the main product variant's options
        const optionSelects = selectorItem.querySelectorAll('select.quantity-break__variant-select');

        if (optionSelects.length === mainProductVariant.options.length) {
          mainProductVariant.options.forEach((optionValue, index) => {
            if (optionSelects[index]) {
              // Ensure the option actually exists before trying to set it.
              // This is a common pitfall if option values don't match.
              const existingOption = Array.from(optionSelects[index].options).find((opt) => opt.value === optionValue);
              if (existingOption) {
                optionSelects[index].value = optionValue;
              } else {
                // console.warn(`QuantityBreaks: Option value "${optionValue}" not found in select for tier ${tierLabel.dataset.input}, item ${selectorItem.dataset.selectIndex || 'N/A'}, select index ${index}.`);
              }
            }
          });
        } else {
          // console.warn('QuantityBreaks: Mismatch in option select count during tier sync for selectorItem:', selectorItem);
        }
      });
    });
  }

  connectedCallback() {
    // Initialize display prices for all tiers after variants are known and DOM is ready
    if (this.hasVariants) {
      this.labels.forEach((label) => {
        const inputKey = label.dataset.input;
        if (this.selectedVariants[inputKey] && this.selectedVariants[inputKey].length > 0) {
          this.updateQuantityOptionDisplayPrice(inputKey);
        }
      });
    }
    // Ensure the initially selected quantity tier's variants are set for the form
    if (this.selectedQuantityInput) {
      this.updateFormVariants(this.selectedQuantityInput.dataset.input);
    }
  }

  initVariants() {
    if (!this.hasVariants) return;
    this.labels.forEach((label) => {
      const inputKey = label.dataset.input;
      const variantsContainer = label.querySelector('.quantity-break__variants');
      if (variantsContainer) {
        let selectedIdsForThisTier = [];
        variantsContainer.querySelectorAll('.quantity-break__selector-item').forEach((selectorItem) => {
          selectedIdsForThisTier.push(selectorItem.dataset.selectedId);
        });
        this.selectedVariants[inputKey] = selectedIdsForThisTier;
      }
    });
  }

  getVariantData() {
    if (!this.variantData && this.jsonData) {
      this.variantData = JSON.parse(this.jsonData.textContent);
    }
    return this.variantData || [];
  }

  handleVariantSelectChangeInTier(event) {
    const changedSelect = event.target;
    const selectorItem = changedSelect.closest('.quantity-break__selector-item');
    const quantityBreakLabel = changedSelect.closest('label.quantity-break');
    const inputKey = quantityBreakLabel.dataset.input;

    const allOptionSelectsInThisItem = selectorItem.querySelectorAll('select.quantity-break__variant-select');
    const currentOptionValues = Array.from(allOptionSelectsInThisItem, (s) => s.value);

    const selectedShopifyVariant = this.getVariantData().find((variant) => {
      if (!variant.options || variant.options.length !== currentOptionValues.length) return false;
      let match = true;
      for (let i = 0; i < variant.options.length; i++) {
        if (variant.options[i] !== currentOptionValues[i]) {
          match = false;
          break;
        }
      }
      return match;
    });

    if (!selectedShopifyVariant) {
      console.error('QuantityBreaks: Could not find matching Shopify variant for options:', currentOptionValues);
      return;
    }

    selectorItem.dataset.selectedId = selectedShopifyVariant.id.toString();
    const selectIndex = parseInt(selectorItem.dataset.selectIndex); // This is the index of the item within the tier (e.g., #1, #2 of Buy 2)

    if (this.selectedVariants[inputKey] && this.selectedVariants[inputKey].length > selectIndex) {
      this.selectedVariants[inputKey][selectIndex] = selectedShopifyVariant.id.toString();
    } else {
      console.error(`QuantityBreaks: selectedVariants structure issue for ${inputKey}, index ${selectIndex}`);
      return;
    }

    // If this tier is currently selected, update the main form variants
    if (this.selectedQuantityInput && this.selectedQuantityInput.dataset.input === inputKey) {
      this.updateFormVariants(inputKey);
    }
    // this.updateMedia(selectedShopifyVariant); // Optional: if you want to update a main product image

    this.updateQuantityOptionDisplayPrice(inputKey);
  }

  updateQuantityOptionDisplayPrice(inputKey) {
    const quantityOptionLabel = this.querySelector(`label.quantity-break[data-input="${inputKey}"]`);
    if (!quantityOptionLabel) return;

    const variantIdsForOption = this.selectedVariants[inputKey];
    if (!variantIdsForOption || variantIdsForOption.length === 0) return;

    let currentTotalOriginalPrice = 0;
    let currentTotalCompareAtPrice = 0; // This will be the sum of compare_at_prices OR prices if compare_at is not higher
    const allProductVariants = this.getVariantData();

    variantIdsForOption.forEach((variantId) => {
      const variant = allProductVariants.find((v) => v.id.toString() === variantId.toString());
      if (variant) {
        currentTotalOriginalPrice += variant.price;
        currentTotalCompareAtPrice +=
          variant.compare_at_price && variant.compare_at_price > variant.price
            ? variant.compare_at_price
            : variant.price;
      }
    });

    const percentageOff = parseFloat(quantityOptionLabel.dataset.percentageOff || 0);
    const fixedAmountOffDollars = parseFloat(quantityOptionLabel.dataset.fixedAmountOff || 0);
    const fixedAmountOffCents = fixedAmountOffDollars * 100;

    let finalPrice = currentTotalOriginalPrice;
    if (percentageOff > 0) {
      finalPrice = finalPrice * (1 - percentageOff / 100);
    }
    if (fixedAmountOffCents > 0) {
      finalPrice = finalPrice - fixedAmountOffCents;
    }
    finalPrice = Math.max(0, finalPrice); // Ensure price doesn't go negative

    const priceElement = quantityOptionLabel.querySelector('.quantity-break__price');
    const comparePriceElement = quantityOptionLabel.querySelector('.quantity-break__compare-price');
    const captionElementSpan = quantityOptionLabel.querySelector('.quantity-break__caption > span'); // Target the inner span
    const captionTemplate = quantityOptionLabel.dataset.captionTemplate;

    if (priceElement) {
      priceElement.textContent = this.formatMoney(finalPrice);
    }

    if (comparePriceElement) {
      if (currentTotalCompareAtPrice > finalPrice) {
        // Show compare-at only if it's greater than the discounted final price
        comparePriceElement.textContent = this.formatMoney(currentTotalCompareAtPrice);
        comparePriceElement.style.display = '';
      } else {
        comparePriceElement.style.display = 'none';
      }
    }

    if (captionElementSpan && captionTemplate) {
      const amountSaved = currentTotalCompareAtPrice - finalPrice;
      if (amountSaved > 0) {
        const amountSavedFormatted = this.formatMoney(amountSaved);
        const amountSavedRoundedFormatted = this.formatMoney(Math.round(amountSaved / 100) * 100); // Simple rounding for placeholder

        let newCaptionText = captionTemplate.replace(/\[amount_saved\]/g, amountSavedFormatted);
        newCaptionText = newCaptionText.replace(/\[amount_saved_rounded\]/g, amountSavedRoundedFormatted);
        captionElementSpan.textContent = newCaptionText;
        captionElementSpan.parentElement.style.display = ''; // Show the parent .quantity-break__caption
      } else {
        captionElementSpan.parentElement.style.display = 'none'; // Hide caption if no savings
      }
    }
  }

  formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      try {
        return Shopify.formatMoney(cents, this.moneyFormat);
      } catch (e) {
        // console.warn('QuantityBreaks: Shopify.formatMoney failed, using fallback.', e);
      }
    }
    // Basic fallback if Shopify.formatMoney is not available or fails
    const value = (cents / 100).toFixed(2);
    let formatString = typeof this.moneyFormat === 'string' ? this.moneyFormat : '${{amount}}'; // Ensure formatString is a string

    // Basic placeholder replacement
    let result = formatString.replace(/\{\{\s*amount\s*\}\}/, value);
    result = result.replace(/\{\{\s*amount_no_decimals\s*\}\}/, (cents / 100).toFixed(0));
    // Add more replacements if your theme uses other placeholders like amount_with_comma_separator etc.

    // If the default Shopify format was something like "${{amount}} USD" and only amount was replaced.
    // This fallback is very basic and might not cover all currency formatting nuances.
    if (result.includes('$') && this.currencySymbol !== '$') {
      result = result.replace('$', this.currencySymbol);
    } else if (!result.includes(this.currencySymbol) && formatString.includes('amount')) {
      // If no currency symbol was in the format string but we have one, prepend/append (heuristic)
      if (formatString.startsWith('{')) {
        // e.g. {{amount}}
        result = this.currencySymbol + result;
      } else {
        // e.g. amount kr.
        // This case is harder to guess, might need more specific logic based on your theme's formats
      }
    }
    return result;
  }

  updateFormVariants(inputKey) {
    // This method prepares the variant IDs for the currently selected quantity tier to be added to the cart.
    // It should populate `this.formVariants` which would then be used by the product form submission logic.
    if (!this.hasVariants || !this.selectedVariants[inputKey]) {
      this.formVariants = [];
      this.updateHiddenInputs([]); // Clear hidden inputs if no variants
      return;
    }
    const selectedIds = this.selectedVariants[inputKey];
    const variantCounts = [];
    selectedIds.forEach((id) => {
      const variantIndex = variantCounts.findIndex((variant) => variant.id === id);
      if (variantIndex < 0) {
        variantCounts.push({ id, quantity: 1 });
      } else {
        variantCounts[variantIndex].quantity += 1;
      }
    });
    this.formVariants = variantCounts;
    this.updateHiddenInputs(this.formVariants);
  }

  updateHiddenInputs(variants) {
    const form = this.closest('form') || document.querySelector(`form[data-product-form][action*="/cart/add"]`);
    if (!form) return;

    // Remove existing quantity break variant inputs
    form.querySelectorAll('input[name="id[]"], input[name="quantity[id]"]').forEach((input) => input.remove());
    form.querySelectorAll('input[name^="properties[_qb_variant_"]').forEach((input) => input.remove());

    if (variants && variants.length > 0) {
      // If we have multiple distinct variants or a single variant with quantity > 1 for the tier
      if (
        variants.length > 1 ||
        (variants.length === 1 && variants[0].quantity > 1 && variants[0].quantity === this.selectedQuantity)
      ) {
        // Use id[] for multiple items/variants
        variants.forEach((variant) => {
          for (let i = 0; i < variant.quantity; i++) {
            const hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = 'id[]';
            hiddenInput.value = variant.id;
            form.appendChild(hiddenInput);
          }
        });
        // Ensure the main quantity input and id input are for a single item or removed
        const mainIdInput = form.querySelector('input[name="id"]');
        if (mainIdInput) mainIdInput.disabled = true; // Or remove
        const mainQuantityInput = form.querySelector('input[name="quantity"][form]'); // The one tied to the form
        if (mainQuantityInput && !mainQuantityInput.name.includes('[')) mainQuantityInput.disabled = true;
      } else if (variants.length === 1 && variants[0].quantity === 1 && this.selectedQuantity === 1) {
        // Single item, use the standard 'id' and 'quantity' inputs
        let idInput = form.querySelector('input[name="id"]');
        if (!idInput) {
          idInput = document.createElement('input');
          idInput.type = 'hidden';
          idInput.name = 'id';
          form.appendChild(idInput);
        }
        idInput.value = variants[0].id;
        idInput.disabled = false;

        const mainQuantityInput = form.querySelector('input[name="quantity"][form]');
        if (mainQuantityInput && !mainQuantityInput.name.includes('[')) {
          mainQuantityInput.value = '1';
          mainQuantityInput.disabled = false;
        }
      }
    } else {
      // No variants for this tier, or not a variant-specific tier.
      // Rely on the main product form's default variant ID and quantity input.
      const mainIdInput = form.querySelector('input[name="id"]');
      if (mainIdInput) mainIdInput.disabled = false;
      const mainQuantityInput = form.querySelector('input[name="quantity"][form]');
      if (mainQuantityInput && !mainQuantityInput.name.includes('[')) mainQuantityInput.disabled = false;
    }
  }

  handleChange(event) {
    const newQuantityValue = parseInt(event.target.value);
    this.selectedQuantity = newQuantityValue;
    this.selectedQuantityInput = event.target; // Update the reference to the checked input
    const inputKey = event.target.dataset.input;

    if (this.hasVariants) {
      this.updateFormVariants(inputKey);
    } else {
      // For non-variant quantity breaks, ensure the main form's quantity is updated
      const form = this.closest('form') || document.querySelector(`form[data-product-form][action*="/cart/add"]`);
      if (form) {
        const mainQuantityInput = form.querySelector(
          'input[name="quantity"]:not([data-quantity-input-desktop]):not([data-quantity-input-mobile])'
        ); // A more generic quantity input
        const idInput = form.querySelector('input[name="id"]');
        if (mainQuantityInput) {
          mainQuantityInput.value = newQuantityValue;
          mainQuantityInput.disabled = false;
        }
        if (idInput) idInput.disabled = false; // Ensure main ID input is enabled

        // Remove id[] inputs if they were added by a variant tier
        form.querySelectorAll('input[name="id[]"]').forEach((inp) => inp.remove());
      }
    }

    // Optional: if you have a gift unlocking mechanism
    if (
      typeof this.quantityGifts !== 'undefined' &&
      this.quantityGifts &&
      typeof this.quantityGifts.unlockGifts === 'function'
    ) {
      this.quantityGifts.unlockGifts(newQuantityValue);
    }
  }
}

if (!customElements.get('quantity-breaks')) {
  customElements.define('quantity-breaks', QuantityBreaks);
}

class CustomProductField extends HTMLElement {
  constructor() {
    super();
    this.fieldName = this.dataset.name;
    this.input = this.querySelector('[type="text"]');
    this.productForm = document.getElementById('product-form-' + this.dataset.section);
    this.value = '';
    this.createInputs();
    this.input.addEventListener('input', this.handleChange.bind(this));
  }
  ['handleChange'](_0x44a0cf) {
    const _0x47fd38 = _0x44a0cf.target.value.trim();
    this.value = _0x47fd38;
    this.productFormInput.value = _0x47fd38;
  }
  ['createInputs']() {
    this.productFormInput = document.createElement('input');
    this.productFormInput.setAttribute('type', 'hidden');
    this.productFormInput.setAttribute('name', 'properties[' + this.fieldName + ']');
    this.productFormInput.value = this.value;
    this.productForm.appendChild(this.productFormInput);
  }
}
customElements.define('custom-product-field', CustomProductField);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.secondarySelectSelector = 'StickyAtcVariantPicker-';
    this.secondarySelect = document.getElementById('' + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = false; // This property was not in your provided snippet but might be used elsewhere
    this.QuantityBreaks = document.getElementById('quantity-breaks-' + this.dataset.section);
    this.addEventListener('change', this.onVariantChange);
    this.variantData = this.getVariantData(); // Cache variant data on construction
  }

  ['onVariantChange']() {
    this.updateOptions();
    this.updateMasterId();
    // It's better to let renderProductInfo handle the initial button state based on fetched data or currentVariant
    // this.toggleAddButton(true, '', false); // Temporarily disable, let renderProductInfo decide final state

    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses(); // This might be important for dependent dropdowns/options

    if (!this.currentVariant) {
      this.toggleAddButton(true, window.variantStrings.unavailable || 'Unavailable', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo(); // This will handle the final button state
      this.updateShareUrl();
    }
  }

  ['updateOptions']() {
    const options = [];
    // Assuming your variant selectors are within this custom element or a known structure
    // The original code used this.querySelectorAll('.product-form__input')
    // If your variant selectors are directly children or within a specific container inside <variant-selects>, adjust if needed.
    const inputContainers = this.querySelectorAll('.product-form__input');

    inputContainers.forEach((container) => {
      // The original code had a complex way to determine type, simplifying based on common patterns
      const selectElement = container.querySelector('select');
      if (selectElement) {
        options.push(selectElement.value);
      } else {
        const checkedRadio = container.querySelector('input[type="radio"]:checked');
        if (checkedRadio) {
          options.push(checkedRadio.value);
        }
      }
    });
    this.options = options;
  }

  ['updateMasterId']() {
    if (!this.options || !this.variantData) {
      this.currentVariant = null;
      return;
    }
    this.currentVariant = this.variantData.find((variant) => {
      return !variant.options
        .map((optionValue, index) => {
          return this.options[index] === optionValue;
        })
        .includes(false);
    });
  }

  ['updateMedia']() {
    if (!this.currentVariant || !this.currentVariant.featured_media) {
      return;
    }
    const mediaGalleries = document.querySelectorAll('[id^="MediaGallery-' + this.dataset.section + '"]');
    mediaGalleries.forEach((gallery) => {
      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(this.dataset.section + '-' + this.currentVariant.featured_media.id, true);
      }
    });

    const productModalContent = document.querySelector(
      '#ProductModal-' + this.dataset.section + ' .product-media-modal__content'
    );
    if (!productModalContent) {
      return;
    }
    const newFeaturedMediaElement = productModalContent.querySelector(
      '[data-media-id="' + this.currentVariant.featured_media.id + '"]'
    );
    if (newFeaturedMediaElement) {
      productModalContent.prepend(newFeaturedMediaElement);
    }
  }

  ['updateURL']() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') {
      return;
    }
    window.history.replaceState({}, '', this.dataset.url + '?variant=' + this.currentVariant.id);
  }

  ['updateShareUrl']() {
    const shareButton = document.getElementById('Share-' + this.dataset.section);
    if (!shareButton || typeof shareButton.updateUrl !== 'function') {
      return;
    }
    shareButton.updateUrl(window.shopUrl + this.dataset.url + '?variant=' + this.currentVariant.id);
  }

  ['updateVariantInput']() {
    const productForms = document.querySelectorAll(
      '#product-form-' + this.dataset.section + ', #product-form-installment-' + this.dataset.section
    );
    productForms.forEach((form) => {
      const idInput = form.querySelector('input[name="id"]');
      if (idInput && this.currentVariant) {
        idInput.value = this.currentVariant.id;
        idInput.dataset.selectedId = this.currentVariant.id; // If you use this data attribute
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (idInput && !this.currentVariant) {
        idInput.value = ''; // Clear if no variant
      }
    });
  }

  ['updateVariantStatuses']() {
    // This method seems to update availability of subsequent options based on prior selections.
    // The original logic was a bit obfuscated. This is a clearer interpretation.
    if (!this.variantData || !this.options) return;

    const formInputs = Array.from(this.querySelectorAll('.product-form__input'));

    formInputs.forEach((container, index) => {
      const currentOptionElements = Array.from(container.querySelectorAll('input[type="radio"], option'));
      if (index === 0) {
        // First option set, enable all that are part of any variant
        const allPossibleValuesForOption1 = [...new Set(this.variantData.map((v) => v.options[0]))];
        this.setInputAvailability(
          currentOptionElements,
          allPossibleValuesForOption1,
          this.variantData.filter((v) => v.available).map((v) => v.options[0])
        );
        return;
      }

      // For subsequent options, filter based on previous selections
      let availableVariants = this.variantData; // Corrected typo here
      for (let i = 0; i < index; i++) {
        availableVariants = availableVariants.filter((variant) => variant.options[i] === this.options[i]);
      }

      const possibleValuesForThisOption = [...new Set(availableVariants.map((v) => v.options[index]))];
      const availableValuesForThisOption = [
        ...new Set(availableVariants.filter((v) => v.available).map((v) => v.options[index])),
      ];

      this.setInputAvailability(currentOptionElements, possibleValuesForThisOption, availableValuesForThisOption);
    });
  }

  ['setInputAvailability'](elements, possibleValues, availableValues) {
    elements.forEach((element) => {
      const value = element.value || element.getAttribute('value'); // For <option> or radio
      const isPossible = possibleValues.includes(value);
      const isAvailable = availableValues.includes(value);

      if (element.tagName === 'OPTION') {
        element.disabled = !isPossible;
        if (!isPossible) {
          element.textContent =
            window.variantStrings.unavailable_with_option.replace('[value]', value) || `${value} (Unavailable)`;
        } else if (!isAvailable) {
          element.textContent =
            window.variantStrings.sold_out_with_option.replace('[value]', value) || `${value} (Sold Out)`;
        } else {
          element.textContent = value;
        }
      } else {
        // Radio button
        element.disabled = !isPossible; // Disable radio if not part of a valid combination
        const label = element.closest('label') || document.querySelector(`label[for="${element.id}"]`);
        if (label) {
          label.classList.toggle('disabled', !isPossible); // Visual cue for label
          if (isPossible && !isAvailable) {
            label.classList.add('sold-out'); // Add a class if it's a valid combo but sold out
          } else {
            label.classList.remove('sold-out');
          }
        }
      }
    });
  }

  ['updatePickupAvailability']() {
    const pickupAvailabilityElement = document.querySelector('pickup-availability'); // Assuming one per page
    if (!pickupAvailabilityElement) {
      return;
    }
    if (this.currentVariant && this.currentVariant.available) {
      if (typeof pickupAvailabilityElement.fetchAvailability === 'function') {
        pickupAvailabilityElement.fetchAvailability(this.currentVariant.id);
      }
    } else {
      pickupAvailabilityElement.removeAttribute('available');
      pickupAvailabilityElement.innerHTML = '';
    }
  }

  ['removeErrorMessage']() {
    const section = this.closest('section');
    if (!section) {
      return;
    }
    const productForm = section.querySelector('product-form'); // Assuming 'product-form' is the custom element tag
    if (productForm && typeof productForm.handleErrorMessage === 'function') {
      productForm.handleErrorMessage(); // Call its method to clear errors
    }
  }

  ['renderProductInfo']() {
    const variantForThisRender = this.currentVariant;

    if (!variantForThisRender && this.options && this.options.some((opt) => opt === undefined || opt === null)) {
      // If options are not fully selected yet, don't assume unavailability, just wait for full selection.
      // The button might be disabled by onVariantChange initially.
      return;
    }

    if (!variantForThisRender) {
      this.toggleAddButton(true, window.variantStrings.unavailable || 'Unavailable', true);
      this.setUnavailable();
      return;
    }

    const sectionIdToFetch = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    const fetchUrl = `${this.dataset.url}?variant=${variantForThisRender.id}&section_id=${sectionIdToFetch}`;

    fetch(fetchUrl)
      .then((response) => response.text())
      .then((responseText) => {
        if (this.currentVariant && variantForThisRender.id !== this.currentVariant.id) {
          // Variant changed again while fetching, new onVariantChange will handle it.
          return;
        }

        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(responseText, 'text/html');

        const updateElement = (currentElId, fetchedElIdPart) => {
          const currentElement = document.getElementById(currentElId);
          const fetchedElement = htmlDocument.getElementById(fetchedElIdPart + sectionIdToFetch);
          if (currentElement && fetchedElement) {
            currentElement.innerHTML = fetchedElement.innerHTML;
            if (fetchedElement.classList.contains('visibility-hidden')) {
              currentElement.classList.add('visibility-hidden');
            } else {
              currentElement.classList.remove('visibility-hidden');
            }
            // Special handling for inventory visibility based on content
            if (currentElId.startsWith('Inventory-') && fetchedElement.innerText.trim() === '') {
              currentElement.classList.add('visibility-hidden');
            }
          }
        };

        updateElement('price-' + this.dataset.section, 'price-');
        updateElement('atc-price-' + this.dataset.section, 'atc-price-');
        updateElement('Sku-' + this.dataset.section, 'Sku-');
        updateElement('Inventory-' + this.dataset.section, 'Inventory-');

        const customLabelElements = document.querySelectorAll('[id^="custom-label-' + this.dataset.section + '"]');
        const fetchedCustomLabelElements = htmlDocument.querySelectorAll(
          '[id^="custom-label-' + sectionIdToFetch + '"]'
        );
        if (customLabelElements.length > 0 && fetchedCustomLabelElements.length === customLabelElements.length) {
          customLabelElements.forEach((label, index) => {
            if (fetchedCustomLabelElements[index]) {
              label.innerHTML = fetchedCustomLabelElements[index].innerHTML;
            }
          });
        }

        if (this.QuantityBreaks) {
          const fetchedQuantityBreaks = htmlDocument.getElementById('quantity-breaks-' + sectionIdToFetch);
          if (fetchedQuantityBreaks) {
            const currentQBVariantMoneyChange = this.QuantityBreaks.querySelectorAll('.variant-money-change');
            const fetchedQBVariantMoneyChange = fetchedQuantityBreaks.querySelectorAll('.variant-money-change');
            currentQBVariantMoneyChange.forEach((el, i) => {
              if (fetchedQBVariantMoneyChange[i]) {
                el.innerHTML = fetchedQBVariantMoneyChange[i].innerHTML;
              }
            });

            // Sync ALL tiers' variant selectors to the main currentVariant
            // This happens BEFORE initVariants is called on QuantityBreaks
            if (this.QuantityBreaks.dataset.hasVariants === 'true' && variantForThisRender) {
              if (typeof this.QuantityBreaks.syncTiersToMainVariant === 'function') {
                this.QuantityBreaks.syncTiersToMainVariant(variantForThisRender);
              }
            }

            if (this.QuantityBreaks.dataset.hasVariants === 'true') {
              if (typeof this.QuantityBreaks.initVariants === 'function') {
                // initVariants will read the data-selected-ids that were just updated by syncTiersToMainVariant
                this.QuantityBreaks.initVariants();
              }
              // Always update all tier prices after sync and init
              if (typeof this.QuantityBreaks.updateQuantityOptionDisplayPrice === 'function') {
                this.QuantityBreaks.labels.forEach((label) => {
                  if (label.dataset.input) {
                    this.QuantityBreaks.updateQuantityOptionDisplayPrice(label.dataset.input);
                  }
                });
              }
            }
          }
        }

        if (this.secondarySelect) {
          const fetchedSecondarySelect = htmlDocument.getElementById(this.secondarySelectSelector + sectionIdToFetch);
          if (fetchedSecondarySelect) {
            this.secondarySelect.innerHTML = fetchedSecondarySelect.innerHTML;
          }
        }

        this.toggleAddButton(
          !variantForThisRender.available,
          variantForThisRender.available
            ? window.variantStrings.addToCart || 'Add to cart'
            : window.variantStrings.soldOut || 'Sold out',
          true
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: sectionIdToFetch,
            html: htmlDocument, // Pass the parsed document, not responseText
            variant: variantForThisRender,
          },
        });
      })
      .catch((error) => {
        console.error('Error fetching product info in VariantSelects:', error);
        this.toggleAddButton(true, window.variantStrings.error || 'Error', true);
      });
  }

  ['toggleAddButton'](disable = true, text, updateText = true) {
    // Ensure this.dataset.section is available
    if (!this.dataset.section) {
      // console.error('VariantSelects: data-section attribute is missing.');
      return;
    }
    const productForm = document.getElementById('product-form-' + this.dataset.section);
    if (!productForm) {
      return;
    }
    const addButton = productForm.querySelector('[name="add"]');
    // The text might be directly in the button or in a child span
    const addButtonTextElement = productForm.querySelector('[name="add"] > span, [name="add"] > .text');

    if (!addButton) {
      return;
    }

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text && updateText && addButtonTextElement) {
        addButtonTextElement.textContent = text;
      } else if (text && updateText && !addButtonTextElement) {
        // If no specific text element, set it on the button itself (less common)
        // addButton.textContent = text;
      }
    } else {
      addButton.removeAttribute('disabled');
      if (updateText && addButtonTextElement) {
        addButtonTextElement.textContent = text || window.variantStrings.addToCart || 'Add to cart';
      } else if (updateText && !addButtonTextElement) {
        // addButton.textContent = text || (window.variantStrings.addToCart || 'Add to cart');
      }
    }
  }

  ['setUnavailable']() {
    const productForm = document.getElementById('product-form-' + this.dataset.section);
    if (!productForm) return;

    this.toggleAddButton(true, window.variantStrings.unavailable || 'Unavailable', true);

    const price = document.getElementById('price-' + this.dataset.section);
    if (price) price.classList.add('visibility-hidden');

    const inventory = document.getElementById('Inventory-' + this.dataset.section);
    if (inventory) inventory.classList.add('visibility-hidden');

    const sku = document.getElementById('Sku-' + this.dataset.section);
    if (sku) sku.classList.add('visibility-hidden');

    const pickupAvailability = document.querySelector('pickup-availability');
    if (pickupAvailability) {
      pickupAvailability.removeAttribute('available');
      pickupAvailability.innerHTML = '';
    }
  }

  ['getVariantData']() {
    this.variantDataStore =
      this.variantDataStore || JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    return this.variantDataStore;
  }
}

customElements.define('variant-selects', VariantSelects);
